<script>
/* eslint-disable */
import { paddy, clamp } from './ivvHelperFunctions';
import { defineComponent } from '@vue/composition-api';

// const ImagePreLoaderWorker = require("worker!./ImagePreLoaderWorker.js");
function loadImage({ index, lod, imgSrc }) {
  const promise = new Promise((resolve) => {
    const imgXhr = new XMLHttpRequest();
    const startTime = Date.now();
    imgXhr.onload = function () {
      const e = {
        index,
        lod,
        imgSrc,
        loadTime: Date.now() - startTime,
        fileSize: parseInt(imgXhr.getResponseHeader('Content-Length')),
      };
      resolve(e);
    };
    imgXhr.open('GET', imgSrc);
    imgXhr.send();
  });
  return promise;
}

Number.prototype.clamp = clamp; // Antipattern, but hey, no time to do it clean as this is refactored away 'soon' anyway...
export default defineComponent({
  render: () => {},
  props: {
    /**
     * the loadPattern decides, in which order the images will be loaded:
     * 0 - linear loading, the images get loaded in order, one after the other
     * 1 - level of detail loading, at first only the first and last image is loaded,
     *     then in the manner of 'divide and conquer' the rest of the images get loaded
     */
    loadPattern: { type: Number, default: 0 },
    /**
     * the progress Intervall describes in which interval an event 'progress' will be executed,
     * if a negative value is given, no event will be dispatched
     * this event has as message an object like this:
     * { downloadSpeed: <speedInB/s | Number>, progress: <progressInPercent | Number> }
     */
    progressInterval: { type: Number, default: -1 },
    /**
     * the count of threads that will download images,
     * chrome allows a maximum of 6 threads, so it shouldn't be higher than that
     */
    imageLoaderThreads: { type: Number, default: 3 },
    /**
     * the source where the images lie, it should be something like:
     * "./img/img-{index}.jpg"
     * where '{index}' will be replaced with the image number with leading zeroes as described in 'imgSequenceSrcDigits'
     */
    imgSequenceSrc: { type: String, required: true },
    /**
     * the count of digits in the image sequence, for example img-0003.jpg
     * would have 4 digits
     */
    imgSequenceSrcDigits: { type: Number, required: true },
    /**
     * the first frame where the first boundary of the animation exists.
     * if it is e.G. 10 and 'frameCount' is set to 100'
     * the image sequence from 'img-010.jpg' to 'img-110.jpg' will be loaded
     */
    firstFrame: { type: Number, default: 0 },
    /**
     * the count of images that should be loaded see the example in @firstFrame
     */
    frameCount: { type: Number, required: true },
    /**
     * the first position(normalized to 0.0 - 1.0) that should be downloaded, to instantly show where the animation begins,
     * after the loading is finished, an event 'initial-load-finished' will be dispatched
     */
    loadInitialPosition: { type: Number, default: 0 },
    /**
     * index for better handling of events at the parent component
     */
    index: { type: Number, default: 0 },
    /**
     * the amount that has to be loaded, it is hot, so if the parent component changes this value, it will automatically load the minimum required amount of images,
     * if the new amount is smaller than the old amount, and all images contained in the old amount are loaded, nothing happens
     */
    preLoadAmount: { type: Number, default: 0 },
  },
  data() {
    return {
      // worker: new ImagePreLoaderWorker(),
      images: [],
      imagesStartedLoading: [],
      imagesLoaded: [],
      imageAmountLoaded: 0,
      imageSizeAmountLoaded: 0,
      startLoadingTime: 0,
      endLoadingTime: 0,
      isLoading: false,
      _stopLoading: true,
    };
  },
  methods: {
    /**
     * returns the string where '{index}' gets replaced by the given index
     */
    getImageSrc(index) {
      return this.imgSequenceSrc.replace(/{index}/, paddy(index, this.imgSequenceSrcDigits));
    },
    /**
     * searches the nearest loaded Image
     *
     * @returns an object with the values img: actual image and index: the corresponding index,
     *          if the input is incorrect, out of range or no image is loaded, null is returned
     */
    getNearestImage(index) {
      const _index = index - this.firstFrame;
      if (_index >= this.images.length || _index < 0) return null;
      if (this.imagesLoaded[_index] && !!this.images[_index]) return { img: this.images[_index], index, position: _index / (this.frameCount - 1) };
      for (let i = 1; i < this.images.length; ++i) {
        if (_index + i < this.images.length && this.imagesLoaded[_index + i] && !!this.images[_index + i])
          return { img: this.images[_index + i], index: index + i, position: (_index + i) / (this.frameCount - 1) };
        if (_index - i >= 0 && this.imagesLoaded[_index - i] && !!this.images[_index - i])
          return { img: this.images[_index - i], index: index - i, position: (_index - i) / (this.frameCount - 1) };
      }
      return null;
    },
    /**
     * the same as in @see getNearestImage just instead of index, a percentual value is used(0.0 - 1.0)
     */
    getNearestImageNorm(position) {
      return this.getNearestImage(Math.round(this.firstFrame + position.clamp(0.0, 1.0) * (this.frameCount - 1)));
    },
    reset() {
      this.stopLoading();
      this.images = [];
      this.imagesStartedLoading = [];
      this.imagesLoaded = [];
      this.imageAmountLoaded = 0;
      this.startLoadingTime = 0;
      this.endLoadingTime = 0;
      for (let i = 0; i < this.frameCount; ++i) {
        this.images.push(null);
        this.imagesStartedLoading.push(false);
        this.imagesLoaded.push(false);
      }
    },
    startLoadingInitialFrame() {
      const initFrame = Math.floor(this.loadInitialPosition * (this.frameCount - 1)).clamp(0, this.frameCount - 1);
      if (!this.imagesStartedLoading[initFrame]) {
        const mainComp = this;
        this.imagesStartedLoading[initFrame] = true;
        this.images[initFrame] = new Image();
        this.images[initFrame].src = this.getImageSrc(initFrame + this.firstFrame);
        this.images[initFrame].onload = function () {
          mainComp.imagesLoaded[initFrame] = true;
          mainComp.imageAmountLoaded++;
          mainComp.$emit('initial-load-finished', mainComp.index);
        };
      } else if (this.imagesLoaded[initFrame]) this.$emit('initial-load-finished', this.index);
    },

    /**
     * starts the loading process, to a percentual amount of all images(amount is between 0 and 1)
     * it first loads an initial image, that will be shown first, if it is finished,
     * an event 'initial-load-finished' will be dispatched
     */
    startLoading() {
      this.startLoadingTime = Date.now();
      this._stopLoading = false;
      this.startLoadingInitialFrame();
      switch (this.loadPattern) {
        default:
        case 0:
          this.startLoadingLinear();
          break;
        case 1:
          this.startLoadingLOD();
          break;
      }
    },
    /**
     * stops the loading process, finishes already started loading progresses
     */
    stopLoading() {
      this._stopLoading = true;
      this.isLoading = false;
    },
    /**
     * @returns the current download speed of all the loaded images, if nothing is loading,
     * it returns the last recorded download speed, or if the download hasn't begun yet, just 0
     */
    downloadSpeed() {
      const downloadSpeed = (this.imageSizeAmountLoaded / (this.endLoadingTime - this.startLoadingTime)) * 1000;
      return isFinite(downloadSpeed) ? downloadSpeed : 0;
    },
    /**
     * is called with an interval, which is initialized in the created function,
     * it dispatches the progress, if it is loading
     */
    progressIntervalDispatch() {
      if (this.isLoading && this.endLoadingTime != 0 && isFinite(this.downloadSpeed()))
        this.$emit('progress', {
          index: this.index,
          downloadSpeed: this.downloadSpeed(),
          progress: this.imageAmountLoaded / this.frameCount,
        });
    },
    /** ******* Level of Detail Loading ******* */
    /**
     * starts a number of LOD loading threads
     */
    startLoadingLOD() {
      if (this.isLoading) return;
      // this.worker.onmessage = this.finishedPreLoadingLODThread;
      this.isLoading = true;
      for (let i = 0; i < this.imageLoaderThreads; ++i) {
        this.startLoadingLODThread(0, 0);
      }
    },
    /**
     * loads all images recursively in the given amount,
     * if it is finished it dispatches the event 'pre-load-finished' and an additional progress event
     */
    startLoadingLODThread(index, lod) {
      if (!this._stopLoading) {
        if (this.imageAmountLoaded / this.frameCount >= this.preLoadAmount.clamp(0.0, 1.0)) {
          if (this.isLoading) {
            this.isLoading = false;
            this.$emit('pre-load-finished', this.index);
            if (this.endLoadingTime != 0 && isFinite(this.downloadSpeed())) {
              this.$emit('progress', {
                index: this.index,
                downloadSpeed: this.downloadSpeed(),
                progress: this.imageAmountLoaded / this.frameCount,
              });
            }
          }
          return;
        }
        let lodFact = Math.pow(2, lod);
        let lodIndex = Math.floor((lodFact * index) / this.frameCount);
        do {
          if (lodIndex / lodFact > 1.0) {
            lod++;
            lodFact = Math.pow(2, lod);
            lodIndex = 0;
          }
          index = Math.floor(((this.frameCount - 1) * lodIndex * 1) / lodFact);
          ++lodIndex;
        } while (!!this.imagesStartedLoading[index] && lodFact <= 2 * this.frameCount);
        if (index >= this.images.length) return;
        this.isLoading = true;
        this.imagesStartedLoading[index] = true;
        loadImage({ index, lod, imgSrc: this.getImageSrc(index + this.firstFrame) }).then((e) => this.finishedPreLoadingLODThread(e));
        // this.worker.postMessage({
        //   cmd: 'load',
        //   index,
        //   lod,
        //   imgSrc: this.getImageSrc(index + this.firstFrame),
        // });
      }
    },
    /**
     * gets called by the preload worker, when it is finished downloading, this should not be called directly,
     * if the preload worker is finished downloading, the actual image has to be loaded into a DOM Element, to be able to get binded instantly
     * after the image is loaded into a DOM Element, it executes another startLoadingLinearThread(recursively)
     */
    finishedPreLoadingLODThread(e) {
      if (!this._stopLoading) {
        this.images[e.index] = new Image();
        this.images[e.index].src = e.imgSrc;
        const mainComp = this;
        this.images[e.index].onload = function () {
          if (!mainComp._stopLoading) {
            mainComp.imagesLoaded[e.index] = true;
            mainComp.imageAmountLoaded++;
            mainComp.imageSizeAmountLoaded += e.fileSize;
            mainComp.endLoadingTime = Date.now();
            const lodFact = Math.pow(2, e.lod);
            const lodIndex = Math.floor((lodFact * e.index) / mainComp.frameCount);
            mainComp.startLoadingLODThread(Math.floor(((mainComp.frameCount - 1) * (lodIndex + 1) * 1) / lodFact), e.lod);
          }
        };
      } else this.imagesStartedLoading[e.index] = false;
    },
    /** ******* Linear Loading ******* */
    /**
     * starts a number of linear loading threads
     */
    startLoadingLinear() {
      if (this.isLoading) return;
      // this.worker.removeEventListener('message', this.finishedPreLoadingLinearThread);
      // this.worker.addEventListener('message', this.finishedPreLoadingLinearThread);
      const initFrame = Math.floor(this.loadInitialPosition * (this.frameCount - 1)).clamp(0, this.frameCount - 1);
      for (let i = initFrame; i < initFrame + this.imageLoaderThreads; ++i) {
        this.startLoadingLinearThread(i);
      }
    },
    /**
     * loads all images recursively in the given amount,
     * if it is finished it dispatches the event 'pre-load-finished'
     */
    startLoadingLinearThread(index) {
      if (!this._stopLoading) {
        if (this.imageAmountLoaded / this.frameCount >= this.preLoadAmount.clamp(0.0, 1.0)) {
          if (this.isLoading) {
            this.isLoading = false;
            this.$emit('pre-load-finished', this.index);
          }
          return;
        }
        for (; this.imagesStartedLoading[index]; ++index);
        if (index >= this.images.length) {
          for (index = 0; this.imagesStartedLoading[index]; ++index);
          if (index >= this.images.length) return;
        }
        this.isLoading = true;
        this.imagesStartedLoading[index] = true;
        loadImage({ index, lod, imgSrc: this.getImageSrc(index + this.firstFrame) }).then((e) => this.finishedPreLoadingLODThread(e));
        // this.worker.postMessage({ cmd: 'load', index, imgSrc: this.getImageSrc(index + this.firstFrame) });
      }
    },
    /**
     * gets called by the preload worker, when it is finished downloading, this should not be called directly,
     * if the preload worker is finished downloading, the actual image has to be loaded into a DOM Element, to be able to get binded instantly
     * after the image is loaded into a DOM Element, it executes another startLoadingLinearThread(recursively)
     */
    finishedPreLoadingLinearThread(e) {
      if (!this._stopLoading) {
        this.images[e.data.index] = new Image();
        this.images[e.data.index].src = e.data.imgSrc;
        const mainComp = this;
        this.images[e.data.index].onload = function () {
          if (!mainComp._stopLoading) {
            mainComp.imagesLoaded[e.data.index] = true;
            mainComp.imageAmountLoaded++;
            mainComp.imageSizeAmountLoaded += e.data.fileSize;
            mainComp.endLoadingTime = Date.now();
            mainComp.startLoadingLinearThread(e.data.index + 1);
          }
        };
      } else this.imagesStartedLoading[e.data.index] = false;
    },
  },
  watch: {
    preLoadAmount(newVal, oldVal) {
      if (newVal > oldVal && !this.isLoading) this.startLoading();
      if (newVal < oldVal) {
        this.stopLoading();
      }
    },
  },
  created() {
    for (let i = 0; i < this.frameCount; ++i) {
      this.images.push(null);
      this.imagesStartedLoading.push(false);
      this.imagesLoaded.push(false);
    }
    if (this.progressInterval > 0) setInterval(this.progressIntervalDispatch, this.progressInterval);
  },
  mounted() {
    if (this.preLoadAmount > 0) {
      this.startLoading();
    }
  },
});
</script>
